import MarkdownIt from "markdown-it";
import hljs from "highlight.js";

/**
 * Shared markdown renderer. Code fences are syntax-highlighted with
 * highlight.js; output is wrapped by callers in a `.prose` container.
 */
function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

const md: MarkdownIt = new MarkdownIt({
  html: false,
  linkify: true,
  typographer: true,
  highlight(code: string, lang: string): string {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return hljs.highlight(code, { language: lang, ignoreIllegals: true }).value;
      } catch {
        /* fall through to escaped plain text */
      }
    }
    return escapeHtml(code);
  },
});

export function renderMarkdown(src: string): string {
  return md.render(src ?? "");
}
